export const FIRST_LEVEL_NAV_HEIGHT = 68;
